import React from "react";
const PaymentSummary = ({ operator, plan, back, mob }) => {
  return (
    <div className="payment-summary-container">
      {/* Left Section - Payment Summary */}
      <div className="payment-summary">
        <h3>Payment Summary</h3>
        <div className="summary-item">
          <span>Bill Amount</span>
          <span>₹ {plan?.price}</span>
        </div>
        <div className="summary-item">
          <span>Platform Fee</span>
          <span>₹ 0.00</span>
        </div>
        <hr />
        <div className="summary-item total">
          <span>Total Payable Amount</span>
          <span>₹ {plan?.price}</span>
        </div>
      </div>

      {/* Right Section - Plan Details */}
      <div className="plan-summary-details">
        <div className="plan-header">
          <div className="d-flex align-center gap1">
            <div className="plan-logo">
              <img src={operator?.icon} alt="Jio Logo" />
            </div>
            <div className="plan-info">
              <h4>{operator?.label}</h4>
              <p>+91 {mob}</p>
            </div>
          </div>
          <button className="change-plan" type="button" onClick={back}>
            ✎ Change Plan
          </button>
        </div>

        <div className="plan-content">
          <p className="validity">Validity</p>
          <h4>Existing Active Plan</h4>
          <p>
            Data Only Pack | Data: 1GB | Voice: NA | SMS: NA | Validity: Active
            Plan.
          </p>
          <p className="note mt1">
            Note: You can recharge with the above plan to avail the same
            benefits as the earlier ₹15 Data Pack.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentSummary;
